import * as React from "react";

const IconLargeArrowRight: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="40" viewBox="0 0 24 40" fill="currentColor"><polygon fill="currentColor" points="24 20 0 40 0 0"/></svg>;
};

export default React.memo(IconLargeArrowRight);
